
import { TranslationSet } from '../types';

export const footer: TranslationSet = {
  'footer.about': {
    en: 'About',
    ja: '概要',
    es: 'Acerca de',
    zh: '关于',
    fa: 'درباره ما'
  },
  'footer.services': {
    en: 'Services',
    ja: 'サービス',
    es: 'Servicios',
    zh: '服务',
    fa: 'خدمات'
  },
  'footer.contact': {
    en: 'Contact Us',
    ja: 'お問い合わせ',
    es: 'Contáctanos',
    zh: '联系我们',
    fa: 'تماس با ما'
  },
  'footer.privacy': {
    en: 'Privacy Policy',
    ja: 'プライバシーポリシー',
    es: 'Política de privacidad',
    zh: '隐私政策',
    fa: 'سیاست حفظ حریم خصوصی'
  },
  'footer.terms': {
    en: 'Terms of Service',
    ja: '利用規約',
    es: 'Términos de servicio',
    zh: '服务条款',
    fa: 'شرایط خدمات'
  },
  'footer.description': {
    en: 'LittleAI Diary helps you document every precious moment of your baby\'s growth journey with AI-powered diary entries, photo galleries, and statistics.',
    ja: 'LittleAI Diaryは、AI駆動の日記エントリー、フォトギャラリー、および統計情報で赤ちゃんの成長の貴重な瞬間をすべて記録するのに役立ちます。',
    es: 'LittleAI Diary te ayuda a documentar cada momento valioso de tu viaje de bebé con entradas de diario, galerías de fotos y estadísticas.',
    zh: 'LittleAI Diary帮助您记录宝宝成长旅程中的每一个珍贵时刻，通过AI驱动的日记条目、照片库和统计数据。',
    fa: 'دفترچه خاطرات LittleAI به شما کمک می‌کند تا هر لحظه ارزشمند از سفر رشد کودک خود را با یادداشت‌های روزانه هوشمند، گالری‌های عکس و آمارها ثبت کنید.'
  },
  'footer.upgradeToPremium': {
    en: 'Upgrade to Premium',
    ja: 'プレミアムにアップグレード',
    es: 'Subscreve a Premium',
    zh: '升级到高级版',
    fa: 'ارتقا به نسخه حرفه‌ای'
  },
  'footer.features': {
    en: 'Features',
    ja: '機能',
    es: 'Funciones',
    zh: '功能',
    fa: 'ویژگی‌ها'
  },
  'footer.createEntries': {
    en: 'Create Entries',
    ja: 'エントリーを作成',
    es: 'Crear entradas',
    zh: '创建条目',
    fa: 'ایجاد یادداشت‌ها'
  },
  'footer.viewEntries': {
    en: 'View Entries',
    ja: 'エントリーを表示',
    es: 'Ver entradas',
    zh: '查看条目',
    fa: 'مشاهده یادداشت‌ها'
  },
  'footer.growthStatistics': {
    en: 'Growth Statistics',
    ja: '成長統計',
    es: 'Estadísticas de crecimiento',
    zh: '成长统计',
    fa: 'آمار رشد'
  },
  'footer.account': {
    en: 'Account',
    ja: 'アカウント',
    es: 'Cuenta',
    zh: '账户',
    fa: 'حساب کاربری'
  },
  'footer.login': {
    en: 'Login',
    ja: 'ログイン',
    es: 'Iniciar sesión',
    zh: '登录',
    fa: 'ورود'
  },
  'footer.signUp': {
    en: 'Sign Up',
    ja: '登録',
    es: 'Registrarse',
    zh: '注册',
    fa: 'ثبت نام'
  },
  'footer.premiumPlan': {
    en: 'Premium Plan',
    ja: 'プレミアムプラン',
    es: 'Plan Premium',
    zh: '高级计划',
    fa: 'طرح حرفه‌ای'
  },
  'footer.copyright': {
    en: 'All rights reserved.',
    ja: '全著作権所有。',
    es: 'Todos los derechos reservados.',
    zh: '版权所有。',
    fa: 'تمامی حقوق محفوظ است.'
  }
};
